var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNextLast = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.749.244c.309.3.333.773.071 1.1l-.071.079L2.07 5l3.679 3.577c.309.3.333.774.071 1.1l-.071.079c-.309.3-.795.323-1.131.07l-.081-.07L.25 5.589c-.309-.3-.333-.773-.071-1.1l.071-.078L4.537.244c.335-.325.877-.325 1.212 0zm5 0c.309.3.333.773.071 1.1l-.071.079L7.07 5l3.679 3.577c.309.3.333.774.071 1.1l-.071.079c-.309.3-.795.323-1.131.07l-.081-.07L5.25 5.589c-.309-.3-.333-.773-.071-1.1l.071-.078L9.537.244c.335-.325.877-.325 1.212 0z",
    transform: "translate(-1344 -696) translate(893 688) translate(451 8) matrix(-1 0 0 1 18 7)"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNextLast, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/next-last.703c15be.svg";
export { ForwardRef as ReactComponent };